import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';

const SZEREPKOROK = [
    { ertek: 'user', felirat: 'Felhasználó' },
    { ertek: 'admin', felirat: 'Admin' },
    { ertek: 'auditor', felirat: 'Auditor' },
];

function szerepkorFelirat(felhasznalo) {
    if (felhasznalo.Foadmin) {
        return 'Főadmin';
    }
    if (felhasznalo.Szerepkor === 'auditor') {
        return 'Auditor';
    }
    return felhasznalo.Szerepkor === 'admin' ? 'Admin' : 'Felhasználó';
}

function szerepkorOsztaly(felhasznalo) {
    return felhasznalo.Foadmin ? 'foadmin' : felhasznalo.Szerepkor;
}

// "2026-10-18 12:30:00" -> "2026. 10. 18. 12:30"
function datumSzoveg(s) {
    if (!s) {
        return '–';
    }
    const m = /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)/.exec(s);
    return m ? m[1] + '. ' + m[2] + '. ' + m[3] + '. ' + m[4] + ':' + m[5] : s;
}

function oldalszamok(oldal, oldalak) {
    const lista = [];
    for (let i = Math.max(1, oldal - 2); i <= Math.min(oldalak, oldal + 2); i++) {
        lista.push(i);
    }
    return lista;
}

// Egy listasor magassága (px); a CSS-ben ugyanennyi. Keskeny képernyőn a sor két soros.
const SOR_MAGASSAG = 41;
const SOR_MAGASSAG_KESKENY = 64;
const ALSO_MARGO = 24;

// Hány sor fér el a képernyőn a lista helyétől lefelé (a kereső, a szűrő és a lapozó a lista fölött van).
function szamolMeret(listaElem) {
    if (!listaElem) {
        return 20;
    }
    const sorMagassag = window.innerWidth < 768 ? SOR_MAGASSAG_KESKENY : SOR_MAGASSAG;
    const felso = listaElem.getBoundingClientRect().top + window.scrollY;
    const hely = window.innerHeight - felso - ALSO_MARGO;
    return Math.max(5, Math.min(100, Math.floor(hely / sorMagassag)));
}

// A felhasználók listája (főadmin): keresés Enterre, szűrés váltógombbal, lapozás,
// szerepkör módosítása felugró panelben.
// Az auditor ugyanezt a listát látja, de csak olvasásra: a sorokra kattintva nem történik semmi, a panel nem nyílik meg.
export default function FelhasznalokOldal({ callAPI, felhasznalo }) {
    const csakOlvas = !(felhasznalo && felhasznalo.foadmin);
    const [kereso, setKereso] = useState('');          // a mezőben lévő szöveg
    const [q, setQ] = useState('');                    // az elküldött (Enterrel indított) keresés
    const [szuro, setSzuro] = useState('mind');           // 'mind' | 'admin' | 'auditor'
    const [oldal, setOldal] = useState(1);
    const [meret, setMeret] = useState(undefined);     // hány sor fér el a képernyőn (a szervernek küldjük)
    const [adat, setAdat] = useState(undefined);       // {felhasznalok, osszes, oldal, oldalak, meret}
    const [kivalasztott, setKivalasztott] = useState(undefined);
    const listaHely = useRef(null);

    // Az oldalméret a képernyő méretéből adódik; átméretezéskor újraszámoljuk.
    useLayoutEffect(() => {
        setMeret(szamolMeret(listaHely.current));
        let idozito;
        function onResize() {
            clearTimeout(idozito);
            idozito = setTimeout(function () { setMeret(szamolMeret(listaHely.current)); }, 250);
        }
        window.addEventListener('resize', onResize);
        return () => { clearTimeout(idozito); window.removeEventListener('resize', onResize); };
    }, []);

    useEffect(() => {
        if (meret === undefined) {
            return;
        }
        let elavult = false;
        callAPI('General.listFelhasznalok', { q: q, oldal: oldal, csakAdmin: szuro === 'admin', csakAuditor: szuro === 'auditor', meret: meret }, function (resp) {
            if (!elavult) {
                setAdat(resp.data);
                if (resp.data.oldal !== oldal) {
                    setOldal(resp.data.oldal);
                }
            }
        });
        return () => { elavult = true; };
    }, [q, oldal, szuro, meret]);

    function onKeyDown_kereso(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            setQ(kereso.trim());
            setOldal(1);
        }
    }

    function onClick_szuro(ertek) {
        setSzuro(ertek);
        setOldal(1);
    }

    function onMentve(frissitett) {
        setAdat(function (regi) {
            return regi === undefined ? regi : Object.assign({}, regi, {
                felhasznalok: regi.felhasznalok.map(function (f) { return f.Id === frissitett.Id ? frissitett : f; })
            });
        });
        setKivalasztott(frissitett);
    }

    const oldalak = adat ? adat.oldalak : 1;
    const aktualisOldal = adat ? adat.oldal : 1;

    return (
        <div className="felhasznalokOldal">
            <div className="eszkozSav">
                <div className="keresoBlokk">
                    <Form.Control
                        className="keresoMezo"
                        type="search"
                        placeholder="Keresés névre vagy e-mail-címre (Enter)"
                        maxLength={100}
                        value={kereso}
                        onChange={function (e) { setKereso(e.target.value); }}
                        onKeyDown={onKeyDown_kereso} />
                </div>
                <div className="szuroSav" role="group" aria-label="Szűrés">
                    <button type="button" className={'szuroGomb' + (szuro === 'mind' ? ' aktiv' : '')} onClick={function () { onClick_szuro('mind'); }}>Mindenki</button>
                    <button type="button" className={'szuroGomb kozepso' + (szuro === 'admin' ? ' aktiv' : '')} onClick={function () { onClick_szuro('admin'); }}>Csak adminok</button>
                    <button type="button" className={'szuroGomb' + (szuro === 'auditor' ? ' aktiv' : '')} onClick={function () { onClick_szuro('auditor'); }}>Csak auditorok</button>
                </div>
            </div>

            {/* A lapozó a lista fölött van; mindig megjelenik, hogy a lista helye ne ugorjon. */}
            <div className="lapozoSav">
                <div className="talalatSzam">{adat !== undefined ? adat.osszes + ' találat, ' + aktualisOldal + '. oldal / ' + oldalak : ' '}</div>
                <div className="lapozo">
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal <= 1} onClick={function () { setOldal(1); }}>«</Button>
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal <= 1} onClick={function () { setOldal(aktualisOldal - 1); }}>‹</Button>
                    {oldalszamok(aktualisOldal, oldalak).map(function (i) {
                        return (
                            <Button key={i} size="sm" variant={i === aktualisOldal ? 'primary' : 'outline-secondary'} onClick={function () { setOldal(i); }}>{i}</Button>
                        );
                    })}
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal >= oldalak} onClick={function () { setOldal(aktualisOldal + 1); }}>›</Button>
                    <Button variant="outline-secondary" size="sm" disabled={aktualisOldal >= oldalak} onClick={function () { setOldal(oldalak); }}>»</Button>
                </div>
            </div>

            <div ref={listaHely}>
                {adat !== undefined && adat.felhasznalok.length === 0 ?
                    <div className="adminUres">Nincs találat.</div>
                    : undefined
                }
                {adat !== undefined && adat.felhasznalok.length > 0 ?
                    <div className="felhasznaloLista">
                        {adat.felhasznalok.map(function (f) {
                            return (
                                <button type="button" key={f.Id} className={'felhasznaloSor' + (csakOlvas ? ' csakOlvas' : '')} tabIndex={csakOlvas ? -1 : undefined} onClick={function () { if (!csakOlvas) { setKivalasztott(f); } }}>
                                    <span className="nev">{f.Nev !== '' ? f.Nev : <i>(nincs név)</i>}</span>
                                    <span className="email">{f.Email}</span>
                                    <span className={'szerepJelveny ' + szerepkorOsztaly(f)}>{szerepkorFelirat(f)}</span>
                                    <span className="belepes">{datumSzoveg(f.Utolsobelepes)}</span>
                                </button>
                            );
                        })}
                    </div>
                    : undefined
                }
            </div>

            <FelhasznaloPopup
                felhasznalo={csakOlvas ? undefined : kivalasztott}
                callAPI={callAPI}
                onHide={function () { setKivalasztott(undefined); }}
                onMentve={onMentve} />
        </div>
    );
}

function FelhasznaloPopup({ felhasznalo, callAPI, onHide, onMentve }) {
    const [szerepkor, setSzerepkor] = useState('user');
    const [visszajelzes, setVisszajelzes] = useState(undefined);   // {tipus: 'siker'|'hiba', szoveg}

    useEffect(() => {
        if (felhasznalo !== undefined) {
            setSzerepkor(felhasznalo.Szerepkor);
            setVisszajelzes(undefined);
        }
    }, [felhasznalo ? felhasznalo.Id : null]);

    function onClick_mentes() {
        callAPI('General.saveFelhasznaloSzerepkor', { felhasznaloID: felhasznalo.Id, szerepkor: szerepkor }, function (resp) {
            setVisszajelzes({ tipus: 'siker', szoveg: 'Mentve' });
            onMentve(resp.data.felhasznalo);
        }, function (resp) {
            setVisszajelzes({ tipus: 'hiba', szoveg: String(resp.userMsg || 'A mentés nem sikerült.') });
            return false;   // a visszajelzés a panelben látszik, nincs felugró üzenet
        });
    }

    if (felhasznalo === undefined) {
        return null;
    }
    const foadmin = felhasznalo.Foadmin;
    const valtozott = szerepkor !== felhasznalo.Szerepkor;

    return (
        <Modal show={true} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{felhasznalo.Nev !== '' ? felhasznalo.Nev : <i>(nincs név)</i>}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <dl className="felhasznaloReszletek">
                    <dt>E-mail-cím</dt><dd>{felhasznalo.Email}</dd>
                    <dt>Létrehozva</dt><dd>{datumSzoveg(felhasznalo.Letrehozva)}</dd>
                    <dt>Utolsó belépés</dt><dd>{datumSzoveg(felhasznalo.Utolsobelepes)}</dd>
                    <dt>Google-fiók</dt><dd>{felhasznalo.Google ? 'van' : 'nincs'}</dd>
                </dl>

                <div className="szerepkorCim">Szerepkör</div>
                <div className="szerepkorValto" role="group" aria-label="Szerepkör">
                    {SZEREPKOROK.map(function (s) {
                        return (
                            <button
                                key={s.ertek}
                                type="button"
                                disabled={foadmin}
                                className={'szerepkorGomb ' + s.ertek + ((foadmin ? 'admin' : szerepkor) === s.ertek ? ' aktiv' : '')}
                                onClick={function () { setSzerepkor(s.ertek); setVisszajelzes(undefined); }}>
                                {s.felirat}
                            </button>
                        );
                    })}
                </div>
                {foadmin ?
                    <div className="szerepkorMegjegyzes">Főadmin (a konfig alapján) – a szerepköre nem módosítható.</div>
                    :
                    <div className="szerepkorMentes">
                        <Button variant="primary" disabled={!valtozott} onClick={onClick_mentes}>Mentés</Button>
                        {visszajelzes !== undefined ?
                            <div className={'visszajelzes ' + visszajelzes.tipus}>{visszajelzes.szoveg}</div>
                            : undefined
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}
